import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { stopPropagation } from '../../../utils/events'
import { Divider } from '../../Divider'
import { useEmailFilesDownloadAll } from '../../Email'
import { ProfileDocumentsWidgetContentSkeleton } from '../ProfileDocumentsWidgetContentSkeleton'
import { ProfileDocumentsWidgetHeaderDownloadAllButton } from '../ProfileDocumentsWidgetHeaderDownloadAllButton'
import { Widget } from '../Widget'
import {
  WidgetContentFilesDocumentsList,
  WidgetContentFilesImagesList,
} from '../WidgetContentFiles'

import { getPreparedDocuments } from './ProfileDocumentsWidget.utils'

import * as styles from './ProfileDocumentsWidget.module.css'

function ProfileDocumentsWidget({
  contentContainerProps: {
    Skeleton: ContentContainerSkeleton = ProfileDocumentsWidgetContentSkeleton,
    ...contentContainerProps
  } = EMPTY_OBJECT,
  downloadFilesApi,
  files = EMPTY_LIST,
  imagesListProps,
  initiallyExpanded,
  isSkeleton,
  scope,
  titleKey = 'Common.ProfileWidgetDocumentsTitleKey',
  widgetProps,
}) {
  const { t } = useTranslation()

  const { documents, images } = getPreparedDocuments(files)

  const { handleClickDownloadAll, modal } = useEmailFilesDownloadAll({
    downloadFilesApi,
    files: [...documents, ...images],
  })

  function handleClickEditButton(event) {
    stopPropagation(event)

    handleClickDownloadAll()
  }

  const hasDocuments = documents?.length > 0
  const hasImages = images?.length > 0

  return isSkeleton || hasDocuments || hasImages ? (
    <Widget
      {...widgetProps}
      contentContainerProps={{
        ...contentContainerProps,
        Skeleton: ContentContainerSkeleton,
      }}
      headerProps={{
        contentProps: {
          actionsProps: {
            EditButton: ProfileDocumentsWidgetHeaderDownloadAllButton,
            editButtonProps: {
              onClick: handleClickEditButton,
            },
          },
        },
      }}
      initiallyExpanded={initiallyExpanded}
      isSkeleton={isSkeleton}
      title={t(titleKey)}
    >
      {hasImages ? (
        <WidgetContentFilesImagesList
          {...imagesListProps}
          items={images}
          scope={scope}
        />
      ) : null}
      {hasImages && hasDocuments ? (
        <Divider className={styles.divider} />
      ) : null}
      {hasDocuments ? (
        <WidgetContentFilesDocumentsList items={documents} scope={scope} />
      ) : null}
      {modal}
    </Widget>
  ) : null
}

export default ProfileDocumentsWidget
